export default __webpack_public_path__ + "static/media/classroom-white.68683517.svg";